Promise = require 'bluebird'
React = require 'react'
$ = require 'jquery'
_ = require 'underscore'
Controller = require 'app/scripts/controller'
{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
ModelLoader = require 'app/scripts/db/model-loader'
{ track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ maybeDisplayMemberLimitsError } = require 'app/scripts/views/board-menu/member-limits-error'
Util = require 'app/scripts/lib/util'
{ unsplashClient, UnsplashTracker } = require '@trello/unsplash'
t = require('app/scripts/views/internal/recup-with-helpers')('create_board')
Alerts = require 'app/scripts/views/lib/alerts'
Confirm = require 'app/scripts/views/lib/confirm'
Dialog = require 'app/scripts/views/lib/dialog'
PopOver = require 'app/scripts/views/lib/pop-over'
{ Storage } = require '@trello/storage'
isDesktop = require('@trello/browser').isDesktop()
OutOfFreeTeamBoards = require('app/common/components/create-board/out-of-free-team-boards').default
helpers = require 'app/scripts/views/board-create/helpers'
BackgroundChooserComponent = require 'app/scripts/views/board-create/background-chooser-component'
ColorChooserComponent = require 'app/scripts/views/board-create/color-chooser-component'
PhotoChooserComponent = require 'app/scripts/views/board-create/photo-chooser-component'
OrgChooserComponent = require 'app/scripts/views/board-create/org-chooser-component'
VisChooserComponent = require 'app/scripts/views/board-create/vis-chooser-component'
{ UpgradePromptFullConnected: UpgradePromptFull } = require 'app/src/components/UpgradePrompts/UpgradePromptFull'
{ Icon, IconName } = require 'app/common/components/controls/icon'
{ CreateBoardTestIds } = require '@trello/webdriverio-tests'
shouldHandleClick = require 'app/scripts/lib/util/should-handle-click'
{ Analytics } = require '@trello/atlassian-analytics'


{ createBackgroundStyle, createColors, createPhotoFromResponse, preloadPermissions, preloadPhotos } = helpers

COLORS = createColors()

link = (t, url, args...) ->
  { attrs, contents } = t.normalizeArgs(args)
  if attrs.href?
    throw Error("Can't specify an href on a `link` tag")
  attrs.href = url

  oldOnClick = attrs.onClick
  attrs.onClick = (e) ->
    if !shouldHandleClick(e)
      return
    e.preventDefault()
    oldOnClick?()
    Controller.navigate(url, trigger: true)
    return

  t.a attrs, contents

module.exports = class CreateBoardComponent extends React.Component
  displayName: 'CreateBoardComponent'

  constructor: (props) ->
    @state =
      # XXX: These three values get out of sync when re-rendering
      # after state changes, which leads to duplicated state in
      # the child components in order to render them correctly.
      # If anyone has ideas on how to use the PopOver lifecycle
      # methods to keep the two in sync, that would be 💯.
      isBackgroundChooserVisible: false
      isColorChooserVisible: false
      isPhotoChooserVisible: false
      isLoadingVisPermissions: false
      isLoadingPhotos: false
      isOrgChooserVisible: false
      isSubmitting: false
      isVisChooserVisible: false
      background: COLORS[0]
      org: null
      orgsWithPermissions: []
      photos: []
      vis: 'private'
      title: props.defaultTitle ? ''
      defaultOrg: props.defaultOrg ? @getBestOrganization()
      deafultVisFlag: featureFlagClient.get('enterprise.default_board_visibility', false)
      sendGASEvent: featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      sendCoreGASEvent: featureFlagClient.get('dataeng.gasv3-core-event-tracking', false)

    @onLdUpdateDefaultVis = @onLdUpdateDefaultVis.bind(@)
    @onUpdateSendGASEvent =  @onUpdateSendGASEvent.bind(@)

    super props

  onUpdateSendGASEvent: (newVal) ->
    @setState({ sendGASEvent: newVal })

  onLdUpdateDefaultVis: (newVal) ->
    @setState({ deafultVisFlag: newVal })

  componentDidMount: ->
    # Ensure that org visibility validation happens on mount
    @loadVisPermissions()
    # Load initial set of photos from Unsplash on mount
    @loadPhotos()
    # Persist width of submit button so we can use it when applying the loading class on submission
    @submitButtonWidth = @submitButtonElem?.getBoundingClientRect().width

    featureFlagClient.on('enterprise.default_board_visibility', false, @onLdUpdateDefaultVis)

    Analytics.sendScreenEvent
      name: 'createBoardModal'

  componentWillUnmount: ->
    featureFlagClient.off 'enterprise.default_board_visibility', @onLdUpdateDefaultVis

  componentDidUpdate: (prevProps, prevState) ->
    if @state.isOrgChooserVisible
      @showOrgChooser()
    if @state.isVisChooserVisible
      @showVisChooser()
    if @state.isBackgroundChooserVisible
      @showBackgroundChooser()
    if @state.isColorChooserVisible && !prevState.isColorChooserVisible
      @showColorChooser()
    if @state.isPhotoChooserVisible && !prevState.isPhotoChooserVisible
      @showPhotoChooser()

  startWithATemplateClick: ->
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'link'
      actionSubjectId: 'startWithTemplateLink'
      source: 'createBoardModal'

  render: t.renderable ->
    {
      background
      isLoadingVisPermissions
      orgsWithPermissions
      org
    } = @state

    t.div =>
      t.form '.create-board-form', { onSubmit: @onSubmit.bind @ }, =>
        # Flex container
        t.div '.form-container', =>
          t.div '.board-tile.create-board-tile', {
            className: t.classify { 'has-photo-background': background.isPhoto }
            ref: (elem) => @createBoardTileElem = elem
            style: createBackgroundStyle background
          }, =>
            t.button '.hide-dialog-trigger.unstyled-button', {
              onClick: @onHideDialogTriggerClick.bind @
              type: 'button'
            }, =>
              t.icon 'close'

            t.div =>
              @renderTitleInput()

            if isLoadingVisPermissions
              t.p '.checking-vis-permissions', =>
                t.text l ['checking visibility permissions']
            else
              if orgsWithPermissions.length
                t.div =>
                  @renderOrgChooserTrigger()

              if org?.allowedVis.length != 0
                t.div =>
                  @renderVisChooserTrigger()

          @renderBackgroundGrid()
        @renderFreeBoardLimitInfo()
        @renderUpgradePromptFullComponent()
        @renderPaidManagedMemberMessage()
        @renderButtons()
        @renderErrorMessage()

  renderTitleInput: =>
    t.input '.subtle-input',
      disabled: @state.isSubmitting
      placeholder: t.l 'add board title'
      onBlur: @onTitleBlur.bind @
      onChange: @onTitleChange.bind @
      ref: (elem) => @titleInputElem = elem
      value: @state.title
      'data-test-id': CreateBoardTestIds.CreateBoardTitleInput

  renderOrgChooserTrigger: =>
    t.button '.subtle-chooser-trigger.unstyled-button.org-chooser-trigger', {
      type: 'button'
      onClick: @onOrgChooserTriggerClick.bind @
      ref: (elem) => @orgTriggerElem = elem
    }, =>
      t.span =>
        if @state.org?
          t.text @state.org.model.get 'displayName'
        else
          t.format 'no team'
      t.icon 'down', { class: 'subtle-chooser-trigger-dropdown-icon light' }

  renderVisChooserTrigger: =>
    t.button '.subtle-chooser-trigger.unstyled-button.vis-chooser-trigger', {
      type: 'button'
      onClick: @onVisChooserTriggerClick.bind @
      ref: (elem) => @visTriggerElem = elem
    }, =>
      switch @state.vis
        when 'private'
          t.icon 'private'
          t.text l ['board perms', 'private', 'name']
        when 'org'
          t.icon 'organization-visible'
          t.text l ['board perms', 'org', 'name']
        when 'enterprise'
          t.icon 'enterprise'
          t.text l ['board perms', 'enterprise', 'name']
        when 'public'
          t.icon 'public'
          t.text l ['board perms', 'public', 'name']
      t.icon 'down', { class: 'subtle-chooser-trigger-dropdown-icon light' }

  renderBackgroundGrid: =>
    if @state.photos.length == 0
      backgrounds = COLORS.slice 0, 8
    else
      backgrounds = @state.photos.slice(0, 4).concat COLORS.slice(0, 4)

    if !(_.find backgrounds, (bg) => bg.value == @state.background.value)
      backgrounds = [@state.background].concat backgrounds.slice(1)

    t.ul '.background-grid', { ref: (elem) => @backgroundGridElem = elem }, =>
      backgrounds.forEach (bg) =>
        t.li '.background-grid-item', =>
          t.button '.background-grid-trigger', {
            key: bg.value
            className: t.classify {
              'is-photo': bg.isPhoto
              selected: @state.background.value == bg.value
            }
            onClick: => @setBackground bg
            style: createBackgroundStyle bg, { isSmall: true }
            title: bg.value if bg.isColor
            type: 'button'
          }, =>
            if @state.background.value == bg.value
              t.icon 'check'
      t.li '.background-grid-item', =>
        t.button '.background-grid-trigger', {
          onClick: @onBackgroundChooserTriggerClick.bind @
          type: 'button'
        }, =>
          t.icon 'overflow-menu-horizontal'

  renderUpgradePromptFullComponent: =>
    { org } = @state
    orgModel = org?.model
    isAtOrOver = orgModel?.isAtOrOverFreeBoardLimit()
    limit = orgModel?.getFreeBoardLimit()

    # Don't show the Upgrade Prompt for:
    # 1. There isn't a selected org or
    # 2. If the user chooses 'No team' for board visibility
    # 3. Paid teams
    # 4. Desktop users
    # 5. If the team has less than 3 boards
    # 6. If the board limit (10) had been reached

    if !orgModel ||
    orgModel?.isPremium() ||
    isDesktop ||
    !limit?.count ||
    isAtOrOver
      return null

    else
      t.createElement UpgradePromptFull,
        className: 'upgrade-prompt-full-create-menu'
        headline: l(['upgrade prompt', 'create board popover', 'headline'], { boardCount: "#{limit.count}" })
        content: l(['upgrade prompt', 'create board popover', 'content-2'])
        cta: l(['upgrade prompt', 'learn more'])
        ctaLink: orgModel.getBillingUrl()
        ctaOnClick: =>
          @onHideDialogTriggerClick()
          if @state.sendGASEvent
            Analytics.sendUIEvent
              action: "clicked",
              source: "createBoardModal",
              actionSubject: "prompt",
              actuionSubjectId: "bcUpgradePrompt"

          trackUe(
            'create board popover',
            'opens',
            'team page bc tab',
            '',
            '',
            'by clicking full upgrade prompt in create board popover'
          )
        hidePlanOverlay: true
        iconName: IconName.Board
        isDarkTheme: true

  renderFreeBoardLimitInfo: =>
    { org } = @state

    # Don't show anything for paid teams
    if (
      !org ||
      !org?.model ||
      org?.model?.isPremium()
    )
      return null

    orgModel = org.model
    isAtOrOver = orgModel.isAtOrOverFreeBoardLimit()
    isClose = orgModel.isCloseToFreeBoardLimit()
    limit = orgModel.getFreeBoardLimit()
    isLimitOverridden = orgModel.isFreeBoardLimitOverridden()

    # Show nothing for desktop users
    if (
      !isClose ||
      (isDesktop && isClose && !isAtOrOver)
    )
      return null

    # Show the pretty upgrade prompt for web users at their limit
    if !isDesktop && isAtOrOver
      t.createElement OutOfFreeTeamBoards
      return

  renderButtons: =>
    { org } = @state
    isAtOrOver = org?.model.isAtOrOverFreeBoardLimit()

    if !isDesktop && isAtOrOver
      t.a '.button.primary', {
        href: org.model.getBillingUrl()
      }, =>
        t.format 'upgrade team'

    else
      t.div '.action-items', =>
        t.button '.button.primary', {
          className: t.classify { disabled: !@canSubmit() }
          disabled: !@canSubmit()
          ref: (elem) => @submitButtonElem = elem
          style: { width: @submitButtonWidth } if @state.isSubmitting && @submitButtonWidth != 0
          type: 'submit'
          'data-test-id': CreateBoardTestIds.CreateBoardSubmitButton
        }, =>
          if @state.isSubmitting
            t.span '.logo-loading.subtle.active'
          else
            # output to the DOM .logo-loading (with display:none) to
            # workaround a Safari bug with animations not starting
            t.span '.logo-loading.subtle'
            t.format 'create board'
        link t, '/templates',
          onClick: @startWithATemplateClick
          className: 'start-with-a-template'
        , =>
          t.span '.icon.icon-md.icon-template-board.light'
          t.format 'start with a template'

  renderErrorMessage: =>
    { org } = @state

    # Show error about why they cannot create board
    if org?.allowedVis.length == 0
      t.div '.create-board-permissions-notice', ->
        if org.model.owned()
          t.raw l('board create restriction admin', { urlSettings: "/#{ org.model.get('name') }/account" })
        else
          t.text l('board create restriction not admin')

  renderPaidManagedMemberMessage: =>
    if Auth.me().isEnterpriseMemberOnNonEnterpriseTeam()
      t.div '.pmmmContainer', ->
        t.p ->
          t.format 'boards can only'

  onOrgChooserTriggerClick: (e) =>
    if @state.isSubmitting then return
    if @state.isOrgChooserVisible then return

    Util.stop e
    @setState { isOrgChooserVisible: true }

  onVisChooserTriggerClick: (e) =>
    if @state.isSubmitting then return
    if @state.isVisChooserVisible then return

    Util.stop e
    @setState { isVisChooserVisible: true }

  onBackgroundChooserTriggerClick: (e) =>
    if @state.isSubmitting then return

    Util.stop e
    @setState { isBackgroundChooserVisible: true }

    if @state.sendGASEvent
      Analytics.sendUIEvent
        action: "clicked",
        actionSubject: "inlineDialog",
        actionSubjectId: "createBoardBackgroundChooserDialog",
        source: "createBoardModal"
    track 'New Board', 'Show Background Chooser'


  onHideDialogTriggerClick: (e) =>
    Util.stop e
    @hideDialog()

  onTitleBlur: (e) =>
    @setState { title: e.target.value.trim() }

  onTitleChange: (e) =>
    @setState { title: e.target.value }

  onSubmit: (e) =>
    Util.stop e

    if !@canSubmit() || maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    @setState { isSubmitting: true }

    # Attributes that will be attached to the board model
    boardAttrs =
      name: @state.title
      idOrganization: @state.org?.model.id

    ownedBoards = _.filter Auth.me().boardList.models, (board) -> board.owned()
    isFirstBoard = (
      # Has no boards
      ownedBoards.length == 0 ||
      # Only has welcome board
      (ownedBoards.length == 1 && ownedBoards[0].isWelcomeBoard())
    )

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend {}, boardAttrs,
      prefs_permissionLevel: @state.vis
      prefs_selfJoin: @state.org? && @state.vis != 'private'
      defaultLists: isFirstBoard || @props.defaultLists == true

    if @state.background.isPhoto
      requestData['prefs_background_url'] = @state.background.value
      eventLabel = 'photo'
    else if @state.background.isColor
      requestData['prefs_background'] = @state.background.value
      eventLabel = 'color'

    track 'New Board', 'New'

    if @isBackgroundDirty
      track 'New Board', 'Custom Background', eventLabel
    else
      track 'New Board', 'Default Background'

    Auth.me().boardList.create boardAttrs, {
      requestData: requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        idOrganization = board.get('idOrganization')

        { category, method, context, gasSource } = @props.trackingOpts
        context ?= {}
        enrichedContext = Object.assign({}, context, { boardId: board.get('id'), teamId: idOrganization })
        trackUe(category, 'adds', 'board', '', '', method, enrichedContext)

        if @state.sendCoreGASEvent
          Analytics.sendTrackEvent
            action: 'created'
            actionSubject: 'board'
            source: gasSource
            containers:
              board:
                id: board.get('id')
              organization:
                id: idOrganization ? ''
            attributes:
              visibility: board.getPermLevel()

        onBackgroundLoad = =>
          Controller.displayBoard({
            idBoard: board.id
            openListComposer: !isFirstBoard
            openCardComposerInFirstList: isFirstBoard
          })

        backgroundImage = board.get('prefs')?.backgroundImage
        if backgroundImage
          unsplashClient.trackDownload(@state.background.metadata.id)

          Util.waitForImageLoad backgroundImage
            .then onBackgroundLoad
            .catch onBackgroundLoad
        else
          onBackgroundLoad()
      error: =>
        @setState { isSubmitting: false }
        Alerts.flash('could not create board', 'error', 'create error')
    }

  hideDialog: ->
    Dialog.hide()

  showOrgChooser: =>
    PopOver.show
      displayType: 'mod-no-header'
      elem: @orgTriggerElem
      # Deferred to allow trigger click handler to decide whether it
      # should show or hide the chooser popover based on state
      hidden: =>
        !@isActiveFormElement() && @orgTriggerElem.focus()
        _.defer => @setState { isOrgChooserVisible: false }
      reactElement: React.createElement OrgChooserComponent,
        key: 'org-chooser'
        orgs: @state.orgsWithPermissions
        selectedOrg: @state.org
        onSelect: (org) =>
          @setState { isOrgChooserVisible: false }
          PopOver.hide()
          @setOrg org
          track 'New Board', 'Change Org'

          if @state.sendGASEvent
            Analytics.sendUIEvent
              action: 'set'
              actionSubject: 'organization'
              source: 'createBoardModal'
              containers:
                organization:
                  id: org?.model.id || ''

  showVisChooser: =>
    PopOver.show
      displayType: 'mod-no-header'
      elem: @visTriggerElem
      # Deferred to allow trigger click handler to decide whether it
      # should show or hide the chooser popover based on state
      hidden: =>
        !@isActiveFormElement() && @visTriggerElem.focus()
        _.defer => @setState { isVisChooserVisible: false }
      reactElement: React.createElement VisChooserComponent,
        key: 'vis-chooser'
        selectedOrg: @state.org
        selectedVis: @state.vis
        onSelect: (vis) =>
          @setState { isVisChooserVisible: false }
          visChange = if @state.vis != vis then 1 else 0

          if vis == 'public'
            Confirm.pushView 'public board confirmation',
              className: 'public-confirmation-button'
              confirmBtnClass: 'primary'
              maxWidth: 370
              model: @model
              fxConfirm: (e) =>
                @setVis vis
                trackUe('new board', 'sets', 'board visibility', '', 'to public', '', { change: visChange })

                if @state.sendGASEvent
                  Analytics.sendTrackEvent
                    action: 'set'
                    actionSubject: 'boardVisibility'
                    source: 'createBoardModal'
                    attributes:
                      visibility: vis
                      change: @state.vis != vis
            return

          @setVis vis
          if vis == 'org'
            trackUe('new board', 'sets', 'board visibility', '', 'to team', '', { change: visChange })
          else if vis == 'private'
            trackUe('new board', 'sets', 'board visibility', '', 'to private', '', { change: visChange })
          else if vis == 'enterprise'
            trackUe('new board', 'sets', 'board visibility', '', 'to enterprise', '', { change: visChange })

          if @state.sendGASEvent
            Analytics.sendTrackEvent
              action: 'set'
              actionSubject: 'boardVisibility'
              source: 'createBoardModal'
              attributes:
                visibility: vis
                change: @state.vis != vis

          PopOver.hide()


  showBackgroundChooser: =>
    { left, top } = @backgroundGridElem.getBoundingClientRect()
    PopOver.show
      clientx: left
      clienty: top
      getViewTitle: -> l ['view title', 'board background']
      hidden: => @setState { isBackgroundChooserVisible: false }
      reactElement: React.createElement BackgroundChooserComponent,
        colors: COLORS
        key: 'background-chooser'
        onColorChooserTriggerClick: => @setState { isColorChooserVisible: true }
        onPhotoChooserTriggerClick: => @setState { isPhotoChooserVisible: true }
        onSelect: @setBackground.bind @
        photos: @state.photos
        selectedBackground: @state.background
      willBePushedUp: => @setState { isBackgroundChooserVisible: true }
      willBePushedDown: => @setState { isBackgroundChooserVisible: false }

  showColorChooser: =>
    PopOver.pushView
      getViewTitle: -> l ['view title', 'change background colors']
      reactElement: React.createElement ColorChooserComponent,
        colors: COLORS
        key: 'color-chooser'
        onSelect: @setBackground.bind @
        selectedBackground: @state.background
      willBePopped: => @setState { isColorChooserVisible: false }

  showPhotoChooser: =>
    PopOver.pushView
      getViewTitle: -> l(['view title', 'change background photos'], {
        unsplashUrl: unsplashClient.attributionUrl
      })
      hasSafeViewTitle: true
      reactElement: React.createElement PhotoChooserComponent,
        key: 'photo-chooser'
        onSelect: @setBackground.bind @
        seedPhotos: @state.photos
        selectedBackground: @state.background
      willBePopped: => @setState { isPhotoChooserVisible: false }

  canSubmit: =>
    {
      isSubmitting,
      title,
      isLoadingVisPermissions,
      org,
    } = @state
    (
      # Not already submitting
      !isSubmitting &&
      # Has a board title
      !!title.trim() &&
      # Is finished loading visibility permissions
      !isLoadingVisPermissions &&
      # Either has no org or has a visibility allowed by the org
      (!org? || org.allowedVis.indexOf(@state.vis) > -1) &&
      # Either has no org or is under the free board limit
      (!org? || !org?.model?.isAtOrOverFreeBoardLimit())
    )

  isActiveFormElement: ->
    ['INPUT', 'BUTTON'].indexOf(document.activeElement.tagName) > -1

  loadVisPermissions: =>
    isPaidManagedEnterpriseMember = Auth.me().isPaidManagedEntMember()

    visibilities = ['private', 'org', 'enterprise', 'public']
    @setState { isLoadingVisPermissions: true }
    preloadPermissions(@state.defaultOrg?.id)
      .then (orgs) =>
        orgsWithPermissions = orgs.filter((org) ->
          !isPaidManagedEnterpriseMember || org.belongsToRealEnterprise()
        ).map((org) ->
          allowedVis = visibilities.filter((vis) -> org.canSetVisibility vis)
          { allowedVis, model: org }
        )

        @setState((state) =>
          {
            isLoadingVisPermissions: false
            orgsWithPermissions
            defaultOrg:
              if _.some(orgsWithPermissions, (orgWithPermission) => orgWithPermission.model == state.defaultOrg)
                state.defaultOrg
              else
                orgsWithPermissions[0]
          })
        @_setOrg _.find orgsWithPermissions, (org) => org.model.id == @state.defaultOrg?.id

  loadPhotos: =>
    @setState { isLoadingPhotos: true }
    preloadPhotos()
      .then (photos) -> photos.map createPhotoFromResponse
      .then (photos) =>
        background = if @isBackgroundDirty then @state.background else photos[0]
        @setState { background, isLoadingPhotos: false, photos }
        backgrounds = if @isBackgroundDirty then photos.concat([background]) else photos
        UnsplashTracker.trackOncePerInterval(backgrounds.map((bg) => bg.value))

  # Call this to ensure that field is not marked as dirty
  _setOrg: (org) =>
    vis =  @state.vis
    # 'org' is not a valid visibility for individuals
    if !org? && (vis == 'org' || vis == 'enterprise')
      vis = 'private'
    else if org?
      # default to 'enterprise' visibility if the field is clean and it's allowed
      if @state.deafultVisFlag && !@isVisDirty && org.allowedVis.indexOf('enterprise') > -1
        vis = 'enterprise'
      # otherwise default to 'org' visibility if the field is clean and it's allowed
      else if !@isVisDirty && org.allowedVis.indexOf('org') > -1
        vis = 'org'
      # otherwise default to the first allowed vis
      else if org.allowedVis.indexOf(vis) == -1
        vis = org.allowedVis[0]

    @setState { org, vis, isSubmitting: false }
    @titleInputElem?.focus()

  setOrg: (org) =>
    if @state.isSubmitting then return
    @_setOrg org
    @isOrgDirty = true

  # Call this to ensure that field is not marked as dirty
  _setVis: (vis) =>
    @setState { vis }

  setVis: (vis) =>
    if @state.isSubmitting then return
    @_setVis vis
    @isVisDirty = true

  # Call this to ensure that field is not marked as dirty
  _setBackground: (background) =>
    @setState { background }

  setBackground: (background) =>
    if @state.isSubmitting then return
    @_setBackground background
    @isBackgroundDirty = true

  getBestOrganization: ->
    me = Auth.me()

    # First look by free boards remaining
    bestOrg = me.organizationList
      .filter((org) => org.getFreeBoardsRemaining() != null)
      .sort((a, b) => a.getFreeBoardsRemaining() - b.getFreeBoardsRemaining())[0]

    return bestOrg if bestOrg?

    # Use number of boards per org as backup b/c limits can be null
    nextBestOrg = me.organizationList
      .sort((a, b) => b.get('boardList').length - a.get('boardList').length)[0]

    return nextBestOrg if nextBestOrg?

    return me.organizationList[0] || null
